/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Translation } from '../../models/translation';

export interface TranslationsControllerFindTranslationsForAppByLanguage$Params {

/**
 * The app id
 */
  appIdentifier: string;

/**
 * The language code
 */
  languageCode: string;
}

export function translationsControllerFindTranslationsForAppByLanguage(http: HttpClient, rootUrl: string, params: TranslationsControllerFindTranslationsForAppByLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Translation>>> {
  const rb = new RequestBuilder(rootUrl, translationsControllerFindTranslationsForAppByLanguage.PATH, 'get');
  if (params) {
    rb.path('appIdentifier', params.appIdentifier, {});
    rb.path('languageCode', params.languageCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Translation>>;
    })
  );
}

translationsControllerFindTranslationsForAppByLanguage.PATH = '/translations/app/{appIdentifier}/language/{languageCode}';
